module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-stone-path.12a31237.png";